<template>
    <div>
        <breadcrumb :routerList="[{to:'/dingd/dingdmainlist',title:'订单管理'},{title:'创建订单'}]"/>


            <!-------------------------------------------------------订单信息-------------------------------------------------------------------->
		<div class="h-piece ddform_disable_cls">
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-left:10px">
                    <h1>订单信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine n-two">
                        <el-form label-position="right" :inline="true" ref="form0" :model="order"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item label="订单类型" class="h-elformWrap-2">
                                <el-input v-model="xsqyStr" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="销售组织" class="h-elformWrap-2">
                                <el-input v-model="xszzStr" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="分销渠道" class="h-elformWrap-2">
                                <el-input v-model="fxqdStr" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="创建人" class="h-elformWrap-2">
                                <el-input v-model="this.order.cuname" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="创建时间" class="h-elformWrap-2">
                                <el-input v-model="this.order.cdate" readonly></el-input>
                            </el-form-item>
							<el-form-item label="增值税登记号" class="h-elformWrap-2" v-if="aflag">
							    <el-input v-model="order.vatNo"></el-input>
							</el-form-item>
							<el-form-item label="税号1" class="h-elformWrap-2" v-if="aflag">
							    <el-input v-model="order.taxNo"></el-input>
							</el-form-item>
							<el-form-item label="数据线" class="h-elformWrap-2" v-if="aflag">
							    <el-input v-model="order.dataWire"></el-input>
							</el-form-item>
							<el-form-item label="注释" class="h-elformWrap-2" v-if="aflag">
							    <el-input v-model="order.note"></el-input>
							</el-form-item>
                            <el-form-item label="报价单" class="h-elformWrap-2" :rules="[
							  { required: true, message: '请上传报价单', trigger: 'change'},
							]">
                                <brupload
                                        :refid=order.id
                                        reftype="订单-外销项目-PI"
                                        :limit="1"
                                        :showtime="false"
                                        uploadflag
                                        delflag
                                >
                                </brupload>
                            </el-form-item>
                            <el-form-item label="PO凭证" class="h-elformWrap-2" :rules="[
							  { required: true, message: '请上传PO凭证', trigger: 'change'},
							]">
                                <brupload
                                        :refid=order.id
                                        reftype="订单-外销项目-PO"
                                        :limit="1"
                                        :showtime="false"
                                        uploadflag
                                        delflag
                                >
                                </brupload>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
            <!-------------------------------------------------------订单信息-------------------------------------------------------------------->

            <!-------------------------------------------------------客户信息-------------------------------------------------------------------->
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-left:10px">
                    <h1>客户信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine n-two">
                        <el-form :model="order" ref="form1" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item prop="soldToName" label="售达方名称" class="h-elformWrap-2">
                                <el-input v-model="order.soldToName" placeholder="请输入" readonly>
                                    <i
                                            v-if="selectDailishang"
                                            class="el-icon-search el-input__icon"
                                            slot="suffix"
                                            @click="openShoudf">
                                    </i>
                                </el-input>
                            </el-form-item>

                            <el-form-item prop="soldToAreaName" label="售达方区域" class="h-elformWrap-2">
                                <el-input v-model="order.soldToAreaName" readonly placeholder="自带出"></el-input>
                            </el-form-item>
                            <el-form-item prop="shipToAreaCode" label="送达方区域" class="h-elformWrap-2">
                                <brselectlazy category="YLCountry_agent"
                                              v-model="order.shipToAreaCode" :v="order.shipToAreaCode" @change="changeArea"
                                              ></brselectlazy>
                            </el-form-item>
                            <el-form-item prop="gjmytk" label="国际贸易条款" class="h-elformWrap-2">
                                <brselect clearable category="YlCommercialTerms" :v="order.gjmytk" :showcode="true"
                                          v-model="order.gjmytk"></brselect>
                            </el-form-item>

                            <el-form-item prop="fktj" label="付款条件"  class="h-elformWrap-2">
                                <brselect clearable category="DD_FKTJ" :v="order.fktj" :showcode = "true" @change="changeFktj"
                                          v-model="order.fktj"></brselect>
                            </el-form-item>

                            <el-form-item prop="fktj" label="上传信用证" v-if="shifouxinyzh" class="h-elformWrap-2">
                                <brupload
                                        :refid=order.id
                                        reftype="订单-外销项目-信用证"
                                        :limit="1"
                                        :showtime="false"
                                        uploadflag
                                        delflag
                                >
                                </brupload>
                            </el-form-item>
                            <el-form-item prop="currencyCode" label="币种"  class="h-elformWrap-2">
                                <brselect clearable category="YLCurrency" :v="order.currencyCode"  @change="changeCurrencyCode"
                                          v-model="order.currencyCode"></brselect>

                            </el-form-item>

                        </el-form>
                    </div>
                </div>
            </div>
        <!-------------------------------------------------------客户信息-------------------------------------------------------------------->
        <!-------------------------------------------------------产品信息-------------------------------------------------------------------->
        <div class="h-table h-mrt30 ljjtablepaddings10" style="margin: 20px 20px 0 20px;">
            <div class="h-pieceTitle2 message">
                <h1 class="h1">产品信息</h1>
            </div>
            <el-table
                    ref="multipleTable"
                    :data="productlist1"
                    stripe
					border
                    style="width: 100%">
                <el-table-column
                        type="index"
                        label="#"
                        width="40">
                </el-table-column>
                <el-table-column
                        prop="cpz"
                        label="产品组"
                        :show-overflow-tooltip="true"
                        width="80">
                </el-table-column>
                <el-table-column
                        prop="materialCode"
                        label="产品编码"
						:show-overflow-tooltip="true"
                        width="220">
                </el-table-column>
                <el-table-column
                        prop="materialName"
                        min-width="220"
						:show-overflow-tooltip="true"
                        label="产品名称">
						<template slot-scope="scope">
							<div style="text-align: left;">
								{{scope.row.materialName}}
							</div>
						</template>
                </el-table-column>

                <el-table-column
                        prop="proBenchmarkPrice"
                        label="基准价"
                        width="150">
						<template slot-scope="scope">
						    <el-input v-model="scope.row.proBenchmarkPrice"
						              placeholder="请输入"
                                      :disabled="true"
						              class="DshuR h-tableInput" auto-complete="off"></el-input>
						</template>
                </el-table-column>
                <el-table-column
                        prop="currencyCode"
                        label="币种"
                        width="110">
                </el-table-column>
				<el-table-column
						v-if="tejieshowflag"
				        prop="specialPrice"
				        label="特价"
				        width="150" >
				    <template slot-scope="scope">
				        <el-select class="h-tableInput" v-model="scope.row.specialOfferCode"
				                   @change="changeTejia($event,scope.row)"
				                   placeholder="请选择" clearable>
				            <el-option
				                    v-for="item in scope.row.tjlist"
				                    :key="item.tjdtid"
				                    :label="item.tejia"
				                    :value="item.tjdtid">
				            </el-option>
				        </el-select>
				    </template>
				</el-table-column>
                <el-table-column
                        prop="expoPrice"
                        label="销售单价"
                        width="150" >
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.expoPrice"
                                  placeholder="请输入"
                                  class="DshuR h-tableInput" auto-complete="off"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="feeyongj"
                        label="佣金/单台"
                        width="110">
                    <template slot-scope="scope">
                        <el-input v-model.number="scope.row.feeyongj"
                                  placeholder="请输入"
                                  class="DshuR h-tableInput" auto-complete="off"></el-input>
                    </template>
                </el-table-column>
                <!-- <el-table-column
                        prop="feebaof"
                        label="保费/单台"
                        width="110">
                    <template slot-scope="scope">
                        <el-input v-model.number="scope.row.feebaof"
                                  placeholder="请输入"
                                  class="DshuR" auto-complete="off"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="feeyunf"
                        label="运费/单台"
                        width="110">
                    <template slot-scope="scope">
                        <el-input v-model.number="scope.row.feeyunf"
                                  placeholder="请输入"
                                  class="DshuR" auto-complete="off"></el-input>
                    </template>
                </el-table-column> -->
                <el-table-column
                        prop="proNumber"
                        label="订单数量"
                        width="120">
                    <template slot-scope="scope">
                        <el-input v-model.number="scope.row.proNumber"
                                  οninput="value=value.replace(/[^\d]/g,'')"
                                  placeholder="请输入"
                                  class="DshuR h-tableInput" auto-complete="off"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="finalPrice"
                        label="成交价"
                        width="110"
                >
                    <template slot-scope="scope">
                        <div style="text-align: right;">{{ scope.row.finalPrice = new big(scope.row.expoPrice || scope.row.extraPrice || scope.row.specialPrice || scope.row.proBenchmarkPrice||0).plus(scope.row.feeyongj||0).plus(scope.row.feebaof||0).plus(scope.row.feeyunf||0).plus(scope.row.extraPrice||0).toString() }}</div>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="totalprice"
                        label= "总价"
                        width="150"
                >
                    <template slot-scope="scope">
                        <div style="text-align: right;">{{ scope.row.totalprice = new big(scope.row.proNumber || 0).times((scope.row.finalPrice||0)).toString() }}</div>
                    </template>
                </el-table-column>
                <!-- <el-table-column
                        prop="wlmaozh"
                        label="毛重"
                        width="90"
                        :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="wljinzh"
                        label="净重"
                        width="90"
                        :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="wlzhongldw"
                        label="重量单位"
                        width="90"
                        :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="wltiji"
                        label="体积"
                        width="90"
                        :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="wltijidw"
                        label="体积单位"
                        width="90"
                        :show-overflow-tooltip="true">
                </el-table-column> -->

                        <el-table-column
                                prop="note1"
                                label="备注"
                                min-width="160"
                        >
                            <template slot-scope="scope">
                                <el-input class="h-tableInput" v-model="scope.row.note1"
                                          placeholder=""
                                           auto-complete="off"></el-input>
                            </template>
                        </el-table-column>

                <el-table-column label="操作" width="100">
                    <template slot-scope="scope">
                       <el-button
                                type="text"
                                size="small"
                                class="h-tableLink h-btn"
                                @click="deleteThis(scope.row)">
                            删除
                        </el-button>
						<!-- <div class="l-operationBox">
							<span class="l-operationlist br-operation-delete" title="删除" @click="deleteThis(scope.row)"></span>
						</div> -->
                    </template>
                </el-table-column>
            </el-table>
            <div style="background-color: rgb(94, 182, 233);" v-if="showaddProductRow" @click="showProcuct1">
                <img src="../../assets/images/pimg/jiahao.png" alt="">
            </div>
            <div class="jieguo">
                <span class="jieguo_label">{{order.currencyCode || ''}}总价</span>
                <span class="jieguo_value">
                    {{ order.orderPrice }}
                </span>

                <span class="jieguo_label">RMB总价</span>
                <span class="jieguo_value">{{ order.orderPriceRbm }}</span>

                <span class="jieguo_label" v-show="needxinjin">现金余额</span>
                <span class="jieguo_value" v-show="needxinjin">{{ this.cashBalance }}</span>

                <span class="jieguo_label" v-show="needxinjin">现金占用</span>
                <!--                <span class="jieguo_value">{{ order.orderPriceXj = (this.cashBalance-order.orderPriceRbm<=0?this.cashBalance:order.orderPriceRbm)}}</span>-->
                <span class="jieguo_value" v-show="needxinjin">{{ order.orderPriceXj = this.needxinjin?(order.orderPrice||0):0}}</span>

                <span class="jieguo_label" v-show="needxindai">信贷选择</span>
                <span class="jieguo_value" v-show="needxindai">
                    <el-select v-model="order.creditid" clearable
                               placeholder="请选择" @change="creditChange">
                        <el-option v-for="item in creditData"
                                   :key="item.id"
                                   :label="`信贷总额：${ item.quota }+信贷账期：${ item.paymentdate }天`"
                                   :value="item.id">
                            <div style="color: #8492a6; font-size: 12px">
                                <i style="float: left">{{ item.creCategory==1?'中信保':item.creCategory==0?'内部专属信贷':item.creCategory==2?'内部通用信贷':'' }}&nbsp;</i>&nbsp;
                                <i style="float: left">信贷总额：{{ item.quota }}</i>&nbsp;
                                <i style="float: right; ">信贷账期：{{ item.paymentdate }}天</i>
                            </div>
                        </el-option>
                    </el-select>
                </span>
                <span class="jieguo_label" v-show="needxindai">信贷占用</span>
                <span class="jieguo_value" v-show="needxindai">{{ order.orderPriceXd }}</span>

                <span class="jieguo_label">净价值</span>
                <span class="jieguo_value">{{(order.orderNetWorth = order.orderPrice )}}</span>
            </div>
        </div>
        <!-------------------------------------------------------产品信息-------------------------------------------------------------------->


        <!--------------------------------------------------------------------收货地址弹出框-------------------------------------------------------->
        <!--物料-->
        <!-- <waixiaowxwl :visible.sync="showwuliaodialog1"
                     v-if="showwuliaodialog1"
                     @choseObj="choseWuliao1"
                     :ddlx="ddlx"
                     :currencyCode="order.currencyCode"
              title="选择预测单"/> -->
			  <wxwl :visible.sync="showwuliaodialog1" v-if="showwuliaodialog1" @choseObj="choseWuliao1" :usercode="order.soldToCode"
			        :ddlx="ddlx" :currencyCode="order.currencyCode"
                    :country="order.shipToAreaCode"
			        title="选择物料" />
		  <!-- 套机-->
		  <taoji :visible.sync="showdialog2" v-if="showdialog2" @choseObj="choseTaoji" :usercode="order.soldToCode"
					 title="选择物料"></taoji>
        <!--售达方-->
        <shoudf :visible.sync="showshdfdialog" v-if="showshdfdialog" @choseObj="choseshoudf" oneflag
                :usercode="currentUser"  :ddlx="ddlx" :xszz="order.saleGroupCode"
                title="选择售达方"/>
        <!--地址信息-->
        <areaSelect :visible.sync="showdizhiflag" v-if="showdizhiflag" @choseObj="choseDizhi" />

            <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    </div>
	<div v-if="taskstatus=='0'">
	    <div class="anniu" v-if="!resubmit">
			<el-button class="h-btn h-bBtn h-bgwhite"  @click="backtolist">返回</el-button>
			<el-button class="h-btn h-bBtn h-bggreen" @click="saveOrSubmit(10)">暂存</el-button>
			<el-button class="h-btn h-bBtn h-bgblueQ2" @click="saveOrSubmit(20)">确认提交</el-button>
	    </div>
	    <div class="anniu" v-else>
			<el-button class="h-btn h-bBtn h-bgwhite"  @click="backtolist">返回</el-button>
			<el-button class="h-btn h-bBtn h-bggreen" @click="resaveOrSubmit(20)">重新提交</el-button>
			<el-button class="h-btn h-bBtn" @click="viewpress">审批跟踪</el-button>
	    </div>
	</div>
	<div class="anniu" v-if="taskstatus == '1'">
		<el-button  @click="this.$store.dispatch('backToTaskIndex')" class="el-button h-btn h-bBtn h-bgblueQ2 el-button--default">返回</el-button>
	</div>
</div>
</template>

<script>
    import big from 'big.js'
    import ss from '../../api/SystemService'
    import waixiaowxwl from '../../components/dialog/wxwl-waixiao'
	import wxwl from '../../components/dialog/wxwl'
    import shoudf from '../../components/dialog/selectshdf'
	import taoji from '../../components/dialog/wxwl-fuwu'
    import _ from "loadsh";

    export default {
        components: {
            waixiaowxwl, shoudf, taoji,wxwl
        },
        data() {
            return {
                submitChongfuFlag:true,
				aflag:false,
				productTypes:[{value:"单机"},{value:"套机"}],
				productType:"",
				showdialog2:false,
				costList:[],

                resubmit:false,
                instid:null,
                taskstatus:0,

                showhistory:false,

                selectDailishang:true,


                showwuliaodialog1:false,
                showwuliaodialog2:false,
                showshdfdialog:false,
                showdizhiflag:false,
                currentUser:null,
                showaddProductRow:true,
                //是否需要信贷
                needxindai:true,
                needxinjin:true,
                //付款方式，不需要信贷
                fjksnotjy:['HT02','LC50'],
                //上传信用证
                shifouxinyzh:false,
                //特价
                tejieshowflag:false,
                //定制展示
                dingzhishowflag:false,

                //现金余额
                cashBalance:0,
                ddlx:null,
                order:{
                    id:null, // 主键
                    orderMainContract:null, // 主合同编号
                    orderSubContract:null, // 分合同编号
                    orderProjectCode:null, // 项目编号
                    orderProjectName:null, // 项目名称
                    orderCategory:null, // 订单类型
                    orderCategory1:null, // 订单详细类型:1-10为内销：1-工程,2-标准,3-改制,4-售后,5-样品机,6-免费,7-展会,8-租赁,9-服务,10-OEM,
                    saleGroupCode:null, // 销售组织编码:6200-青岛海尔生物医疗-香港销组织,9390-青岛,9391-上海,9370-青岛海特生物医疗-销售组织
                    disChannelCode:null, // 分销渠道编码:00-通用分销渠道,X1-香港外销渠道,Z1-上海直销渠道
                    zCode:null, // 分销渠道编码-子编码
                    customerChannelCode:null, // 客户渠道
                    isStockUp:null, // 是否备货      1：是；0：否
                    orderStatus:null, // 订单状态： 10:暂存  20:审核中, 21:订单管理员通过, 22:订单管理员未通过, 23:财务经理未通过, 24:财务经理通过   30:sap已提交,31:sap待审核,32:sap已通过
                    instid:null, // 流程id
                    taskId:null, // 流程id
                    tuihyy:null, // 退货原因
                    tuihyydes:null, // 退货原因说明
                    contactName:null, // 联系人名称
                    receivedTime:null, // 预计收货时间
                    soldToCode:null, // 售达方编码
                    soldToName:null, // 售达方名称
                    soldToAreaCode:null, // 售达方地区编码
                    soldToAreaName:null, // 售达方地区名称
                    shipToCode:null, // 送达方编码
                    shipToName:null, // 送达方名称
                    shipToAreaCode:null, // 送达方地区编码
                    invoiceCode:null, // 开票方编码
                    payerCode:null, // 付款方编码
                    currencyCode:null, // 币种编码
                    currencyCodeStr:null, // 币种编码
                    orderPrice:null, // 订单总价
                    exchange:null, // 对人民币的汇率
                    orderPriceRbm:null, // 订单总价rmb
                    orderPriceXj:0, // 订单现金占用
                    creditid:null, // 信贷id
                    orderPriceXd:0, // 订单信贷占用
                    orderNetWorth:null, // 订单净价值
                    poId:null, // PO号
                    areaId:null, // 区域详情表关联id
                    dcCode:null, // 配送中心编码
                    toProvincesCode:null, // 送达省份编码
                    toCityCode:null, // 送达城市编码
                    note:null, // 订单备注
                    note1:null, // 产品备注
                    postcode:null, // 邮政编码
                    firsttelephone:null, // 第一个电话
                    secondtelephone:null, // 第二电话
                    extraPrice:null, // 定制加价
                    customized:null, // 定制需求
                    sapsended:null, // 是否已提交sap,1-是,0-否
                    toAddress:null, // 收货地址
                    toCompanyname:null, // 送达方公司全称
                    posnr:null, // 外销:销售和分销凭证的项目号
                    inco1:null, // 外销:国际贸易条款 (部分1)
                    inco2:null, // 外销:国际贸易条款 (部分2)
                    submitflag:null,//提交标志
                    gjmytk:null, //国际贸易条款
                    fktj:null, //付款条件
                    categoryName:null,
                    category1Name:null,
                    saleGrputName:null,
                    disChannelName:null,
                    zcodeName:null,
					costCenter:null,
					businessReason:null,
                },

                //产品list
                productlist1:[],

                //用户信贷list
                creditData:[],
                //是否计算信贷
                creditFlag:false,
            }


        },
        //页面加载前事件
        created() {
            let id = this.$route.query.ywid;
            let instid = this.$route.query.instid;
            let taskid = this.$route.query.taskid;
            let taskstatus = this.$route.query.taskstatus|0;

            //代办打开的
            if(id && instid){
                this.resubmit = true;
                this.instid = instid;
                this.taskstatus = taskstatus;
                this.order.taskId = taskid;
                if(taskstatus == '1'){
                    // 直接设置经销商
                    this.selectDailishang = false;
                    const parent = document.querySelector(".input");
                    parent.className = "input el-input ";//改变父集的class,把父集改成可编辑状态，
                    //2.在设置input属性
                    //获取input
                    const input = document.querySelector(".input input");
                    //设置input的属性为false
                    input.disabled = false;
                }
            }
            this.getOrder(id||this.$route.query.id);
        },
        mounted(){

        },
        computed:{
            xsqyStr() {
                if(this.order.category1Name){
                    return this.order.categoryName +"/"+ this.order.category1Name
                }
                return this.order.categoryName
            },
            xszzStr() {
                return "["+this.order.saleGroupCode+"]"+this.order.saleGrputName
            },
            fxqdStr() {
                if(this.order.zcodeName){
                    return this.order.disChannelName +"/"+ this.order.zcodeName
                }
                return this.order.disChannelName
            }
        },
        watch:{
            productlist1:{
                deep: true,
                handler(newValue, oldValue) {
                    console.log("列表的刷新：",newValue)
                    _.forEach(newValue,(o,i)=>{
                        o.totalpricermb = new big(o.totalprice).times(o.exchangermb).toFixed(2);
                    });
                    //计算总金额
                    this.order.orderPrice = _.reduce(_.map(newValue,"totalprice"),function (sum,v) {
                        return new big(sum).plus(v).toString();
                    },0)

                    if(this.needxindai && this.creditFlag){
                        this.order.orderPriceXd = this.order.orderPrice;
                    }
                    this.order.orderPriceRbm = new big(this.order.orderPrice).times(this.order.exchange||0).toFixed(2);
                },
            }
        },
        methods: {
			choseTaoji(attr){

				var list = attr[0].componentList;
				for(var i=0;i<list.length;i++){
					var obj = list[i];
					var wl = this.wlToProject(obj);

					if(this.productlist1.length!=0){
					    var headobj = _.head(this.productlist1)
					    //不存在，是一个新的产品型号编码
					    if(headobj.proModelCode != wl.proModelCode){
					        this.$msg.msge("只能选择同一种产品大类型号！");
					        this.showwuliaodialog1 = false;
					        return false;
					    }
					    //不存在，是一个新的产品型号编码
					    if(headobj.currencyCode != wl.currencyCode){
					        this.$msg.msge("只能选择同一种产品大类型号！");
					        this.showwuliaodialog1 = false;
					        return false;
					    }
					}
					//添加行项目
					this.addProject(wl)
				}
				this.showdialog2 = false;
			},
            getOrder(id){
                ss.OrderMainService.selectById(id).then(rd=>{
                    console.log("订单信息：",rd);
                    _.assign(this.order,rd.obj)

                    this.ddlx = this.order.orderCategory+","+(this.order.orderCategory1||'');
                    var type = this.order.orderCategory1||'';
                    //付款条件
                    this.setFkfsXindai(this.order.fktj);

                    // --------获取完售达方，在设置行项目行项目
                    if(rd.obj.products && rd.obj.products.length>0){
                        //加载完现金跟信贷，在插入行项目
                        Promise.all([this.getCredit()]).then(()=>{
                            rd.obj.products.forEach((obj)=>{
                                if(obj){
                                    this.addProject(obj)
                                }
                            })
                        })
                    }
					// this.order.soldToCode="9900000005"
                    //已有经销商
                    if(this.order.soldToCode){
                        ss.selectUserAgent.getOneShoudf(this.order.soldToCode).then(rd=>{
                            this.choseshoudf(rd,true);
                        })
                    }
                })
            },
            //         有个付款方式，TT只用现金，不能选信贷，
            // 其他的类型：什么60、90、120啥的必须选择信贷，信贷的账期必须大于等于付款方式的账期。现金跟信贷不能混用。
            // 信用证：现金跟信贷都不能占用，财务审核过了就行
            changeFktj(o){
                //重置信贷
                this.order.creditid='';
                this.order.orderPriceXd = 0;
                this.needxinjin = true;
                this.needxinjin = true;
                this.setFkfsXindai(o.code);

            },
            setFkfsXindai(fkfs){
                // HT02: T/T Advance
                // LC50: 信用证
                // fjksnotjy:['HT02','LC50'],
                if(_.includes(['HT02','LC50','LCHY','LC5M'], fkfs)){
                    //信用证
                    if(fkfs == "LC50" || fkfs == "LCHY" || fkfs == "LC5M" ){
                        this.shifouxinyzh = true;
                        this.needxinjin = false;
                    }else{
                        this.shifouxinyzh = false;
                    }
                    this.needxindai=false;
                }else{
                    // 有个付款方式，TT只用现金，不能选信贷，
                    // 只能用信贷，不能用现金
                    this.needxinjin = false;
                    this.needxindai = true;
                    this.shifouxinyzh = false;
                    this.getCredit()
                }

            },
            viewpress(r){
                this.showhistory = true;
            },
            backtolist(){
              this.$router.go(-1);
            },
            saveOrSubmit(v){

                let countryList = this.$store.getters.dictlist("YLCountry_agent");
                //提交时校验是否过期送达方区域
                let countryName = _.find(countryList,{code:this.order.shipToAreaCode}).name;
                if(countryName.indexOf('停用')!=-1){
                    this.$msg.msge("送达方区域已停用请重新选择！");
                    return;
                }


                for(var i=0;i<this.productlist1.length;i++){
                    if(!this.productlist1[i].expoPrice){
                        this.$msg.msge("第"+(i+1)+"行销售单价不能为空");
                        return;
                    }
                    if(this.productlist1[i].currencyCode != this.order.currencyCode){
                        this.$msg.msge("第"+(i+1)+"行币种不同！");
                        return;
                    }
                }
                this.order.orderStatus=v
                // 校验是否大于预测剩余数量
                // var sfdxy = _.every(this.productlist1,function(o) { return o.ycavailableNum>proNumber; })
                if(v=='10'){
                    this.order.submitflag='暂存'
                }else if(v=='20'){
                    this.order.submitflag='提交'
                }
                this.order.products = this.productlist1;
                if(this.order.submitflag=='提交'){

                    this.$refs['form1'].validate((valid1) => {
                        if (valid1) {
                            this.$msg.confirm("确认提交？",()=>{
                                this.submitForm();
                            })
                        }else{
                            this.$msg.msge("请完善基本信息后提交");
							return;
                        }
                    });
                }else{
                    this.submitForm();
                }
            },
            submitForm(){
                if(this.submitChongfuFlag){
                    this.submitChongfuFlag = false;
                    ss.OrderMainService.saveOrSubmit(this.order).then(rd=>{
                        this.submitChongfuFlag = true;
                        if(rd.f){
                            if(this.order.submitflag=='提交'){
                                this.$msg.msgs("提交成功！")
                                this.$router.push({path:'/dingd/dingdwxlist'})
                            }else{
                                this.$msg.msgs("暂存成功！")
                            }
                        }else{
                            this.$msg.msge(rd.msg);
                        }
                    })
                }else{
                    this.$msg.msge("重复点击提交，请稍后操作！");
                }
            },
            resaveOrSubmit(v){

                let countryList = this.$store.getters.dictlist("YLCountry_agent");
                //提交时校验是否过期送达方区域
                let countryName = _.find(countryList,{code:this.order.shipToAreaCode}).name;
                if(countryName.indexOf('停用')!=-1){
                    this.$msg.msge("送达方区域已停用请重新选择！");
                    return;
                }


                this.order.orderStatus=v
                this.order.products = this.productlist1;
                this.$refs['form1'].validate((valid1) => {
                    if (valid1) {
                        this.$msg.confirm("确认提交？",()=>{
                            this.order.submitflag = '重新提报'
                            ss.OrderMainService.saveOrSubmit(this.order).then(rd=>{
                                this.$router.push({path:'/dingd/dingdmainlist'})
                            })
                        })
                    }else{
                        this.$msg.msge("请完善基本信息后提交");
                        return;
                    }
                });

            },
            //查询用户余额
            // queryMoney() {
            //     ss.OrderService.queryMoney(this.order.soldToCode).then(rd => {
            //         this.cashBalance = rd.obj.cashBalance || '0';
            //     });
            // },
            // //查询用户所有信贷
            // getCredit() {
            //     //重置信贷
            //     this.order.creditid=null;
            //     this.order.orderPriceXd = 0;
            //     var params={};
            //     params.salegroupcode = this.order.saleGroupCode;
            //     //列表中的第一个的产品大类
            //     var newlist = _.uniqBy(this.productlist1,"proModelCode");
            //     //有不同的产品大类
            //     if(this.productlist1.length != newlist.length){
            //         params.cpdlcode = '';
            //     }else{
            //         //同一个产品大类
            //         params.cpdlcode = _.head(this.productlist1).proModelCode||'';
            //     }
            //     params.usercode = this.order.soldToCode;
            //     ss.OrderMainService.getUserCredit(params).then(rd => {
            //         console.log("用户信贷list：",rd)
            //         this.creditData = rd;
            //     })
            // }
            // ,
            //查询用户，用户余额，所有信贷
            getCredit(gscode) {
                if(this.order.soldToCode){
                    var params={};
                    //列表中的第一个的产品大类
                    var cpdl = _.uniq(_.map(this.productlist1,"proModelCode"));
                    if(cpdl.length == 1){
                        params.cpdlcode = cpdl[0];
                    }
                    params.salegroupcode = this.order.saleGroupCode;
                    params.usercode = this.order.soldToCode;
                    params.fktj = this.order.fktj; // 付款提交
                    return ss.OrderMainService.getUserMoneyCredit(params).then(rd => {
                        console.log(rd)
                        this.creditData = rd.xd;
                        this.cashBalance = rd.xj ? (rd.xj.cashBalance || 0) : 0;
                        // this['order'+gscode].creditData=rd.xd;
                        // this['order'+gscode].xianjye=rd.xj.cashBalance||0;
                    })
                }
            },
            // 选择具体的信贷
            creditChange(v){
                if(v){
                    var xd = _.find(this.creditData,{id:v})
                    console.log(xd)
                    //现金，大于订单总额
                    if(xd.quota >= this.order.orderPrice ){
                        this.order.orderPriceXd = this.order.orderPrice;
                        this.creditFlag = true;
                    }else{
                        this.$msg.msge("该信贷可用余额不足，请重新选择！");
                        this.order.creditid='';
                        this.order.orderPriceXd = 0;
                        this.creditFlag = false;
                        return;
                    }
                }else{

                    this.order.creditid='';
                    this.order.orderPriceXd = 0;
                    this.creditFlag = false;
                }

            },

            //选择售达方
            openShoudf(){

                this.showshdfdialog = true;
            },

            // changeflag:是否已选择售达方改变
            choseshoudf(obj,changeflag){
                console.log("选择的售达方：",obj);
                // 清空物料
                if(this.order.soldToCode != obj.usercode){
                    this.productlist1 = [];
                }else {
                    if(this.productlist1){
                        for(var i = 0;i<=this.productlist1.length;i++){
                            var data = this.productlist1[i];
                            if(data.currencyCode != "USD"){
                                this.productlist1 = [];
                            }
                        }
                    }
                }
                this.order.soldToName = obj.username;
                this.order.soldToCode = obj.usercode;
                this.order.soldToAreaCode = obj.area;
                this.order.soldToAreaName = obj.areaname ;
                this.order.gjmytk=obj.gjmytk; //国际贸易条款
                this.order.fktj=obj.fktj; //付款条件
                //判断选择信贷下拉菜单是否展示
                this.changeFktjNew(obj.fktj);
                // this.order.currencyCode = changeflag ? this.order.currencyCode: obj.currency ;
				this.order.currencyCode = "USD";
                this.order.currencyCodeStr = "USD";
                // 获取对人民币的汇率
                if(this.order.currencyCode!='CNY'){
                    ss.OrderMainService.getExchange({fromCurrency:this.order.currencyCode,toCurrency:"CNY"}).then(rd => {
                        this.order.exchange = rd;
                    })
                }
                this.order.inco2 =  obj.gjmytk2;
                this.showshdfdialog = false;
				if(obj.usercode.substring(0,1)=="A"||obj.usercode.substring(0,1)=="a"){
					this.aflag = true;
				}else{
					this.aflag = false;
				}
              this.order.shipToAreaCode = null;
            },
            //币种改变的时候
            changeCurrencyCode(o){
                // 如果存在行项目
                this.productlist1 = [];
                console.log("this.order.currencyCodeStr",this.order.currencyCodeStr)

                console.log("this.order.currencyCode",this.order.currencyCode)
                //币种改变，重新获取税率
                ss.OrderMainService.getExchange({fromCurrency:this.order.currencyCode,toCurrency:"CNY"}).then(rd => {
                    this.order.exchange = rd;
                })
            },
            //删除该行项目产品信息
            deleteThis(x) {
                this.$msg.confirm("确认删除？",()=>{
                    this.productlist1 = _.reject(this.productlist1, {'id': x.id});
                    // 再次查询一遍，查询信贷（有部分是专属信贷）
                    this.getCredit();
                })
            },

            //选择物料
            //选择物料
            showProcuct1() {
                if(!this.order.soldToCode){
                    this.$msg.msge("请先选择售达方信息！")
                    return;
                }
                if (this.order.shipToAreaCode == null || this.order.shipToAreaCode == '') {
                    this.$msg.msge("送达方区域不可为空！");
                    return;
                }
				this.showwuliaodialog1 = true;
            },
            changeArea(){
              //增加判断只允许9900000079送达方选择英国
              if(this.order.soldToCode != '9900000079' && this.order.shipToAreaCode == 'GB'){
                this.$msg.msge("送达方区域英国不可选择！");
                this.order.shipToAreaCode = null;
                return;
              }
            },
            //选择物料
            choseWuliao1(objs) {
                for(var i=0;i<objs.length;i++){
                    var wl = this.wlToProject(objs[i]);
                    //添加行项目
                    this.addProject(wl)
                    this.showwuliaodialog1 = false;
                }
                // 查询信贷（有部分是专属信贷）
                this.getCredit();
            },
            addProject(obj){
                if(obj.tjlist && obj.tjlist.length>0 && !this.tejieshowflag){
                    this.tejieshowflag = true;

                }
                // if(this.order.currencyCode != obj.currencyCode){
                //     this.$msg.msge("该产品跟售达方币种不一致，请重新选择！");
                //     this.showwuliaodialog1 = false;
                //     return false;
                // }
                // 设置特价余量
                const checktejia = _.find(obj.tjlist,{tjdtid:obj.specialOfferCode})
                if(checktejia){
                    obj.specialPriceNum=checktejia.sysl
                }
                this.productlist1.push(obj);
            },
            wlToProject(obj){
                console.log("选中的物料",obj)
                var wl = {};
                wl.id=this.$util.getUuid();
                wl.materialCode=obj.matecode;//物料编码
                wl.materialName=obj.matedes;//物料名称
                wl.proModelCode=obj.cpdlcode;//产品型号编码
                wl.proModelName=obj.cpdlname;//产品型号名称
                wl.cpz = obj.cpz; //产品组
                wl.dwcode=obj.dwcode;//单位
                wl.dwname=obj.dwname;//单位
                wl.feeyongj=obj.feeyongj||"";//佣金
                // wl.feebaof=obj.feebaof||0;//保费
                // wl.feeyunf=obj.feeyunf||0;//运费
                wl.proNumber="";//产品数量
                wl.proBenchmarkPrice=obj.jizhj;//产品基准价
                wl.expoPrice=obj.jizhj;//默认=产品基准价
                //默认是可以修改的
                wl.expoPriceReadonly = false;
                wl.currencyCode=obj.currency;//币种编码
                wl.specialOfferCode=null; // 特价版本
                wl.specialPrice=null; // 特价价格
                wl.specialPriceNum=null; // 特价价格
                wl.ycid = obj.yccode;//预测人
                wl.ycavailableNum = obj.availableNum;//预测剩余数量
                wl.ycrcode = obj.ycrcode;//预测人
                wl.ycrname = obj.ycrname;//预测人
                wl.isCustommed=obj.isCustommed; // 是否定制     1：是   0 否
                wl.extraPrice=null; // 定制加价
                wl.extraDes=obj.extraDes; // 定制需求
                //毛净体
                // wl.wlmaozh = obj.wlmaozh; //毛重-->
                // wl.wljinzh = obj.wljinzh; //净重-->
                // wl.wlzhongldw = obj.wlzhongldw; //重量单位-->
                // wl.wltiji = obj.wltiji; //体积-->
                // wl.wltijidw = obj.wltijidw; //体积单位-->

                wl.finalPrice=0;//成交价
                wl.totalprice=0;//产品总价
                wl.tjlist=obj.tjlist;

                wl.fromCurrency = obj.currency;
                wl.toCurrency = this.order.currencyCode;
                //对人民币的汇率
                wl.exchangermb = this.order.exchange;
                //公司
                wl.gscode = this.order.saleGroupCode;
                wl.proType='自产'; //自产还是oem
                //对订单的上的币种汇率，
                wl.exchange = 1;
                // if(this.order.currencyCode == obj.currency){
                //     wl.exchange = 1
                // }else {
                //     ss.OrderMainService.getExchange({fromCurrency:obj.currency,toCurrency:this.order.currencyCode}).then(rd => {
                //         wl.exchange = rd;
                //     })
                // }
				wl.havePrice=obj.havePrice;
				wl.taxCode="J0";
                return wl;
            },

            //选择地址
            selectAreadialog() {
                this.showdizhiflag = true;
            },
            choseDizhi(obj) {
                console.log("choseDizhi",obj)
                this.order.addressCode = obj.id;
                this.order.areaId = obj.id;
                this.order.toAddress = obj.quobj.namepath;
                if(obj.zhenobj){
                    this.order.toAddress = obj.zhenobj.namepath;
                }
                this.order.toAddress = this.order.toAddress + obj.addrdetail

                this.order.toProvincesCode = obj.shengobj.name;
                this.order.toCityCode = obj.shiobj.name;

                this.showdizhiflag = false;
            },
            changeFktjNew(o){
                //重置信贷
                this.order.creditid='';
                this.order.orderPriceXd = 0;
                this.needxinjin = true;
                this.needxinjin = true;
                this.setFkfsXindai(o);

            },
        }
    }

</script>


<style scoped>
    .queren {
        background-color: #006aca;
        color: white;
    }

    .anniu {
        display: flex;
		justify-content: center;
		align-items: center;
    }

    .zancun {
        background-color: #24b5b8;
        color: white;
    }

    .quxiao, .zancun {

        width: 100px;
    }
    .jieguo {
        border-bottom: 1px solid rgb(238, 236, 236);
        display: flex;
    }
    .jieguo .jieguo_label{
        width: 2rem;
        text-align: right;
        background-color: #ebf5ff;
        font-size: 12px;
        color: #616467;
        height: 0.4rem;
        line-height: 0.4rem;
        padding: 0 0.05rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .jieguo .jieguo_value{
        width: 20%;
        font-size: 15px;
        color: #616467;
        padding: 0px 8px;
        height: 0.4rem;
        line-height: 0.4rem;
    }
    img {
        width: 25px;
        padding: 5px 0;
        margin-left: 8rem;
    }

    .newProject {
        margin: 0 20px;
        background-color: rgb(94, 182, 233);
    }
    .h-piece {
        margin: 20px;
    }
    .DshuR {
        width: 100%;
        height: 100%;
        border: none;
    }


    .message {
        padding: 20px 0;
        margin-bottom: 0;
        background-color: white;
    }

    .n-xiao .h-formbLine .h-elformWrap-2,
    .n-two .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
    }

    .el-cascader {
        line-height: normal;
    }
</style>
<style>
    .n-two .h-formbLine .el-form-item__content .el-select,
    .n-two .el-form .h-formbLine .el-form-item__content .el-select {
        width: 0;
    }

    .n-xiao .h-formbLine .el-form-item__label,
    .n-two .h-formbLine .el-form-item__label {
        width: 43%;
    }

    .n-xiao .h-formbLine .el-form-item__content,
    .n-two .h-formbLine .el-form-item__content {
        width: 57%;
    }


    /* .el-table__header .el-table-column--selection .cell .el-checkbox::after {
        content: "全选";
        color: white;
        background-color: rgb(93, 172, 236);
        font-size: 10px;
    } */
</style>

<style scoped lang="scss">
    .areaSelect {
        position: fixed;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        top: 0;
        left: 0;
        z-index: 2019;

        .centerBlock {
            width: 700px;
            height: 400px;
            padding: 20px;
            border-radius: 20px;
            background-color: white;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
</style>
<style>
    .aaa .el-dialog__headerbtn {
        display: none;
    }
    .ddform_disable_cls .el-form-item__content .el-input__inner[disabled] {
        color: #868686;
    }
	.ljjtablepaddings10 .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
	}
	.ljjtablepaddings10 .h-tableInput .el-input__icon{
		line-height: 0.25rem;
	}
</style>
